/* eslint-disable no-useless-escape */
function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

function validateUrl(text: string) {
  const re =
    /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;
  return re.test(text);
}

function validateRtloUrl(text: string) {
  const re = /^(https?:\/\/)?([\[0-9\p{L}\-.]+)\.([0-9\p{L}\-.]{2,6})([\/\w \.-]*)*\/?$/u;
  return re.test(text);
}

function validateAlphaNumeric(text: string) {
  const re = /[^0-9\p{L}\-. \s]/gu;

  if (re.test(text)) {
    return false;
  } else {
    return true;
  }
}

function validateAlphanumericMore(text: string) {
  const re = /<("[^"]*"|'[^']*'|[^'">])*>/;

  if (re.test(text)) {
    return false;
  } else {
    return true;
  }
}

function validatePropertyName(text: string) {
  const re = /^(?![0-9]*$)[ A-Za-z0-9_Üüöä\/&^-ñ`´~çß\']*$/;

  if (re.test(text)) {
    return true;
  } else {
    return false;
  }
}

function validateNumericDecimal(text: string) {
  const re = /^\d{1,3}(\.\d{1,2})?$/;
  return re.test(text);
}

function validNumbers(value: string) {
  return /^\d*$/.test(value);
}

function minDateSet() {
  return '1500-01-01';
}

function validatePassword(text: string) {
  // Matches Cognito pool policy: min 8 chars, uppercase, lowercase, digit, any symbol
  const re = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).*$/;
  return re.test(text);
}

function validateLetters(text: string) {
  const re = /^[A-Za-z ]+$/;
  return re.test(text);
}

function validateFileName(text: string) {
  const re = /^[\w\-. ]+$/;
  return re.test(text);
}

//-------------RTLO-----------------

//-----------title validations
function titleValidation(text: string) {
  const re = /^[0-9\p{L}\-._, ]*$/u;
  return re.test(text);
}

function titleLimit(text: string) {
  if (text.length > 40) {
    return false;
  } else {
    return true;
  }
}

function titleLimit100(text: string) {
  if (text.length > 100) {
    return false;
  } else {
    return true;
  }
}
//-----------comment validations
function commentValidation(text: string) {
  const re = /^[0-9\p{L}\-._, ]*$/u;
  return re.test(text);
}

function commentLimit(text: string) {
  if (text.length > 500) {
    return false;
  } else {
    return true;
  }
}

function twentyLimit(text: string) {
  if (text.length > 20) {
    return false;
  } else {
    return true;
  }
}

const validations = {
  validateEmail,
  validateUrl,
  validateRtloUrl,
  validateAlphaNumeric,
  validateAlphanumericMore,
  validatePropertyName,
  validateNumericDecimal,
  validNumbers,
  validatePassword,
  validateLetters,
  validateFileName,
  minDateSet,
  titleValidation,
  titleLimit,
  titleLimit100,
  commentLimit,
  commentValidation,
  twentyLimit,
};

export default validations;
